// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10yqU","controls":"styles_controls__2OQDP","charLimit":"styles_charLimit__2tsz6","input":"styles_input__2FMW5","send":"styles_send__2csZe"};